import { parseISO, isWeekend as dfIsWeekend, eachDayOfInterval, isValid } from 'date-fns';

export const isWeekend = (date) => {
  if (!(date instanceof Date)) return false;
  return dfIsWeekend(date);
};

export const toDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value === 'string') {
    const d = parseISO(value);
    return isValid(d) ? d : null;
  }
  return null;
};

export const countBusinessDays = (startISO, endISO, workweek = [1, 2, 3, 4, 5]) => {
  const start = toDate(startISO);
  const end = toDate(endISO);
  if (!start || !end || start > end) return 0;
  const set = new Set(workweek.map(Number));
  const days = eachDayOfInterval({ start, end });
  let count = 0;
  for (const d of days) {
    if (set.has(d.getDay())) count += 1;
  }
  return count;
};
